/* eslint-disable arrow-body-style */
/* eslint-disable react/display-name */
/* eslint-disable react/no-multi-comp */
/* eslint-disable capitalized-comments */
import { createContext, memo, useCallback, useContext, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { ToastContainer } from "react-bootstrap";
import classNames from "classnames";
import { v4 as uuidv4 } from "uuid";

import NotificationToast from "./NotificationToast";
import { useAuth } from "../services/wp.auth.service";
import { userCanRegister } from "../helpers/authHelpers";

const NotificationsContext = createContext(null);

const areEqual = ({ notification: { id: prevId } }, { notification: { id } }) => {
	// eslint-disable-next-line eqeqeq
	return id == prevId;
};

// eslint-disable-next-line react/prop-types
const Notification = memo(({ notification, onClose }) => (
	<NotificationToast
		notification={notification}
		onClose={onClose}
	/>
), areEqual);

export const NotifcationsContextProvider = ({ children }) => {
	const { user } = useAuth();

	const [notifications, setNotifications] = useState([]);

	const addNotification = useCallback((newNotification) => setNotifications((prev) => [
		...prev, {
			id: uuidv4(),
			...newNotification
		}
	]), []);

	const contextProps = useMemo(() => ({
		addNotification,
		notifications
	}), [notifications]);

	const handleHide = useCallback((id) => setNotifications((prev) => prev.filter((notification) => notification.id !== id)), []);
	const canRegister = useMemo(() => userCanRegister(user), [user]);

	return (
		<NotificationsContext.Provider value={contextProps}>
			{children}
			<ToastContainer
				className={
					classNames(
						"p-3 position-fixed",
						{
							"can-register": canRegister
						}
					)
				}
				id="site-notifications"
				position="bottom-end"
			>
				{notifications.map((notification) => (
					<Notification
						key={notification.id}
						notification={notification}
						onClose={handleHide}
					/>))}
			</ToastContainer>
		</NotificationsContext.Provider>
	);
};

NotifcationsContextProvider.propTypes = {
	children: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.element)]).isRequired
};

export const useNotifications = () => useContext(NotificationsContext);
